<template>
    <div :style="dimensionStyle" class="shadow-sm d-flex flex-column align-items-center justify-content-center app-box rounded-extra p-1">
        <div style="width: 80px; height: 80px;" class="rounded-extra"
             :style="{ backgroundColor: blockColor }">
            <div class="d-flex flex-column align-items-center mx-auto h-100">
                <i class="fad fa-browser m-auto fa-2x" :style="{ color: themeColor }"></i>
            </div>
        </div>
        <div class="font-weight-bold text-center text-sm mt-2" :style="textStyle" >
            {{website.name}}
        </div>
    </div>
</template>

<script>
    export default {
        name: 'WebsiteDisplay',
        props: ['website', 'defaultThemeColor'],
        data() {
            return {
                model: webase.model
            }
        },
        computed: {
            blockColor() {
                return this.defaultThemeColor + '40'
            },
            themeColor() {
                return this.defaultThemeColor
            },
            dimensionStyle() {
                return this.model.isMobile ? 'width: 120px; height: auto;' : 'width: 180px; height: 180px;'
            },
            textStyle() {
                return this.model.isMobile ? 'width: 100px;' : 'width: 150px;'
            }
        }
    }
</script>

<style>

</style>
